export var cards = [{
  title: '今日订单',
  value: 'todayOrders'
}, {
  title: '今日成交额',
  value: 'todayTransactionAmount',
  isMark: true
}, {
  title: '累计单量',
  value: 'accumulativeOrders'
}, {
  title: '累计优惠金额',
  value: 'accumulativeDiscountAmount',
  isMark: true
}, {
  title: '累计成交金额',
  value: 'accumulativeTransactionAmount',
  isMark: true
}, {
  title: '累计成交商品件数',
  value: 'accumulativeTransactionQuantity'
}, {
  title: '累计成交客户数',
  value: 'accumulativeCustomerNumber'
}, {
  title: '客单价',
  value: 'customerUnitPrice'
}, {
  title: '平均折扣率',
  value: 'averageDiscountRate'
}];